import config from '../config';
import App from '../containers/App/App';

// Components
import PeriodFilterPage from '../components/PeriodFilter/PeriodFilterPage';
import CountryListPage from '../components/PhoneInput/PhoneInputPage';
import AMLCheckResult from '../containers/AMLCheckResult';
import AMLHistoryPage from '../containers/AMLHistoryPage/AMLHistoryPage';
import AccessRestricted from '../containers/AccessRestricted';
import Account from '../containers/Account';
import AddCardToWallet from '../containers/AddCardToWallet';
import Address from '../containers/Address';
import AddressAmlDetails from '../containers/AddressAmlDetails';
import Addresses from '../containers/Addresses';
import AllCards from '../containers/AllCards';
import AllWalletsPage from '../containers/AllWalletsPage';
import AmlCheck from '../containers/AmlCheck';
import Asset from '../containers/Asset';
import Assets from '../containers/Assets';
import Auth from '../containers/Auth';
import BillingCurrency from '../containers/BillingCurrency';
import BuyBillingCurrency from '../containers/BuyBillingCurrency';
import BuyBillingAddress from '../containers/BuyBillingCurrency/components/BuyBillingAddress';
import BuyBillingAsset from '../containers/BuyBillingCurrency/components/BuyBillingAsset';
import CardEdit from '../containers/CardEdit';
import CardSpendingLimits from '../containers/CardSpendingLimits';
import CardTermsConditions from '../containers/CardTermsConditions';
import CardWithdrawal from '../containers/CardWithdrawal';
import CardWithdrawalAccount from '../containers/CardWithdrawal/components/CardWithdrawalAccount';
import CardWithdrawalAsset from '../containers/CardWithdrawal/components/CardWithdrawalAsset';
import CloseCard from '../containers/CloseCard/CloseCard';
import CloseCardConfirm from '../containers/CloseCard/components/CloseCardConfirm';
import CloseCardWithdrawalAsset from '../containers/CloseCard/components/CloseCardWithdrawalAsset';
import CloseCardWithdrawalAccount from '../containers/CloseCard/components/CloseCardWithdrawalAccount';
import ConfirmCaptcha from '../containers/ConfirmCaptcha';
import CreateAddress from '../containers/CreateAddress';
import CreatePassword from '../containers/CreatePassword';
import CreatePin from '../containers/CreatePin';
import DeviceVerification from '../containers/DeviceVerification/DeviceVerification';
import DeviceVerificationInfo from '../containers/DeviceVerification/components/DeviceVerificationInfo/DeviceVerificationInfo';
import DeviceVerificationVerify from '../containers/DeviceVerification/components/DeviceVerificationVerify';
import Devices from '../containers/Devices';
import EditCardPersonalInfo from '../containers/EditCardPersonalInfo';
import EnterPin from '../containers/EnterPin';
import ErrorPage from '../containers/ErrorPage';
import ExportTransactions from '../containers/ExportTransactions';
import Languages from '../containers/Languages/Languages';
import MainPage from '../containers/MainPage';
import OpenCard from '../containers/OpenCard';
import ChooseCardColor from '../containers/OpenCard/components/ChooseCardColor';
import InsertPersonalData from '../containers/OpenCard/components/InsertPersonalData/InsertPersonalData';
import OpenCardTerms from '../containers/OpenCard/components/OpenCardTerms/OpenCardTerms';
import PersonalInfo from '../containers/PersonalInfo';
import Portfolio from '../containers/Portfolio';
import Receive from '../containers/Receive';
import ReceiveAddress from '../containers/Receive/components/ReceiveAddress';
import ReceiveAsset from '../containers/Receive/components/ReceiveAsset';
import ReceiveQR from '../containers/Receive/components/ReceiveQR';
import RecoveryPassword from '../containers/RecoveryPassword';
import RecoveryPin from '../containers/RecoveryPin';
import Send from '../containers/Send';
import SendAccount from '../containers/Send/components/SendAccount';
import SendAmount from '../containers/Send/components/SendAmount';
import SendAsset from '../containers/Send/components/SendAsset';
import SendConfirm from '../containers/Send/components/SendConfirm';
import SendRecipient from '../containers/Send/components/SendRecipient';
import SignIn from '../containers/SignIn/SignIn';
import SignUp from '../containers/SignUp';
import StubPage from '../containers/StubPage';
import TopUpCard from '../containers/TopUpCard';
import TopUpCardAccount from '../containers/TopUpCard/components/TopUpCardAccount';
import TopUpCardAmount from '../containers/TopUpCard/components/TopUpCardAmount';
import TopUpCardAsset from '../containers/TopUpCard/components/TopUpCardAsset';
import TopUpCardConfirm from '../containers/TopUpCard/components/TopUpCardConfirm';
import TransactionDetails from '../containers/TransactionDetails';
import TransactionsHistoryPage from '../containers/TransactionsHistoryPage/';
import VerificationEmailPhone from '../containers/VerificationEmailPhone';
import WelcomePage from '../containers/WelcomePage';
import CardDetails from '../containers/CardDetails';

const { routes: urls } = config;

const routes = [
	{
		id: 0,
		path: urls.main,
		element: <App />,
		errorElement: <ErrorPage />,
		children: [
			{
				id: 0,
				index: true,
				element: <WelcomePage />,
			},
			{
				id: 1,
				path: urls.auth,
				element: <Auth />,
			},
			{
				id: 2,
				path: urls.signUp,
				element: <SignUp />,
			},
			{
				id: 14,
				path: urls.createPin,
				element: <CreatePin />,
			},
			{
				id: 16,
				path: urls.createPassword,
				element: <CreatePassword />,
			},
			{
				id: 17,
				path: urls.signIn,
				element: <SignIn />,
			},
			{
				id: 3,
				path: urls.portfolio,
				element: <Portfolio />,
				// children: [
				// 	{
				// 		path: urls.portfolioId,
				// 		element: <Portfolio />,
				// 		children: [
				// 			{
				// 				path: urls.portfolioAssets,
				// 				element: <Portfolio />,
				// 			},
				// 			{
				// 				path: urls.portfolioHistory,
				// 				element: <Portfolio />,
				// 			},
				// 		],
				// 	},
				// ],
			},
			{
				id: 4,
				path: urls.assets,
				element: <Assets />,
			},
			{
				id: 5,
				path: urls.account,
				element: <Account />,
			},
			{
				id: 6,
				path: urls.addresses,
				element: <Addresses />,
			},

			{
				id: 7,
				path: urls.error,
				element: <ErrorPage />,
			},
			{
				id: 8,
				path: urls.send,
				element: <Send />,
				children: [
					{
						index: true,
						element: <SendAsset />,
					},
					{
						path: urls.sendAccount,
						element: <SendAccount />,
					},
					{
						path: urls.sendAccount,
						element: <SendAccount />,
					},
					{
						path: urls.sendRecipient,
						element: <SendRecipient />,
					},
					{
						path: urls.sendAmount,
						element: <SendAmount />,
					},
					{
						path: urls.sendConfirm,
						element: <SendConfirm />,
					},
				],
			},
			{
				id: 9,
				path: urls.transactionDetails,
				element: <TransactionDetails />,
			},
			{
				id: 10,
				path: urls.receive,
				element: <Receive />,
				children: [
					{
						path: urls.receiveAsset,
						element: <ReceiveAsset />,
					},
					{
						path: urls.receiveAddress,
						element: <ReceiveAddress />,
					},
					{
						path: urls.receiveQR,
						element: <ReceiveQR />,
					},
				],
			},
			{
				id: 11,
				path: urls.billingCurrency,
				element: <BillingCurrency />,
			},
			{
				id: 28,
				path: urls.buyBillingCurrency,
				element: <BuyBillingCurrency />,
				children: [
					{
						index: true,
						element: <BuyBillingAsset />,
					},
					{
						path: urls.buyBillingAddress,
						element: <BuyBillingAddress />,
					},
				],
			},
			{
				id: 29,
				path: urls.verifyDevice,
				element: <DeviceVerification />,
				children: [
					{
						index: true,
						element: <DeviceVerificationInfo />,
					},
					{
						path: urls.verifyDeviceVerify,
						element: <DeviceVerificationVerify />,
					},
				],
			},
			{
				id: 12,
				path: urls.recoveryPassword,
				element: <RecoveryPassword />,
			},
			{
				id: 13,
				path: urls.recoveryPin,
				element: <RecoveryPin />,
			},
			{
				id: 20,
				path: urls.enterPin,
				element: <EnterPin />,
			},
			{
				id: 22,
				path: urls.stubPage,
				element: <StubPage />,
			},
			{
				id: 23,
				path: urls.createPin,
				element: <CreatePin />,
			},
			{
				id: 24,
				path: urls.transactionsHistory,
				element: <TransactionsHistoryPage />,
			},
			{
				id: 25,
				path: urls.allWallets,
				element: <AllWalletsPage />,
			},
			{
				id: 26,
				path: urls.address,
				element: <Address />,
			},
			{
				id: 27,
				path: urls.asset,
				element: <Asset />,
			},
			{
				id: 28,
				path: urls.createAddress,
				element: <CreateAddress />,
			},
			{
				id: 29,
				path: urls.confirmCaptcha,
				element: <ConfirmCaptcha />,
			},
			{
				id: 30,
				path: urls.devices,
				element: <Devices />,
			},
			{
				id: 31,
				path: urls.languages,
				element: <Languages />,
			},
			{
				id: 32,
				path: urls.openCard,
				element: <OpenCard />,
				children: [
					{
						index: true,
						element: <OpenCardTerms />,
						handle: { header: '' },
					},
					{
						path: urls.chooseCardColor,
						element: <ChooseCardColor />,
						handle: { header: 'Open card' },
					},
					{
						path: urls.insertPersonalData,
						element: <InsertPersonalData />,
						handle: { header: 'Your personal info' },
					},
				],
			},
			{
				id: 34,
				path: urls.selectCountryCode,
				element: <CountryListPage />,
			},
			{
				id: 37,
				path: urls.addressAmlDetails,
				element: <AddressAmlDetails />,
			},
			{
				id: 36,
				path: urls.mainPage,
				element: <MainPage />,
			},
			{
				id: 37,
				path: urls.cardTerms,
				element: <CardTermsConditions />,
			},
			{
				id: 38,
				path: urls.cardEdit,
				element: <CardEdit />,
			},
			{
				id: 39,
				path: urls.allCards,
				element: <AllCards />,
			},
			{
				id: 40,
				path: urls.editPersonalInfo,
				element: <EditCardPersonalInfo />,
			},
			{
				id: 41,
				path: urls.personalInfo,
				element: <PersonalInfo />,
			},
			{
				id: 42,
				path: urls.verificationEmailPhone,
				element: <VerificationEmailPhone />,
			},
			{
				id: 43,
				path: urls.addCardToWallet,
				element: <AddCardToWallet />,
			},
			{
				id: 44,
				path: urls.periodFilterPage,
				element: <PeriodFilterPage />,
			},
			{
				id: 45,
				path: urls.topUpCard,
				element: <TopUpCard />,
				children: [
					{
						index: true,
						element: <TopUpCardAsset />,
					},
					{
						path: urls.topUpCardAccount,
						element: <TopUpCardAccount />,
					},
					{
						path: urls.topUpCardAmount,
						element: <TopUpCardAmount />,
					},
					{
						path: urls.topUpCardConfirm,
						element: <TopUpCardConfirm />,
					},
				],
			},
			{
				id: 47,
				path: urls.closeCard,
				element: <CloseCard />,
				children: [
					{
						path: urls.closeCardConfirm,
						element: <CloseCardConfirm />,
					},
					{
						path: urls.closeCardWithdraw,
						element: <CloseCardWithdrawalAsset />,
					},
					{
						path: urls.closeCardWithdrawAccount,
						element: <CloseCardWithdrawalAccount />,
					},
				],
			},
			{
				id: 48,
				path: urls.exportTransactions,
				element: <ExportTransactions />,
			},
			{
				id: 49,
				path: urls.cardWithdrawal,
				element: <CardWithdrawal />,
				children: [
					{
						index: true,
						element: <CardWithdrawalAsset />,
					},
					{
						path: urls.cardWithdrawalAccount,
						element: <CardWithdrawalAccount />,
					},
				],
			},
			{
				id: 50,
				path: urls.cardSpendingLimits,
				element: <CardSpendingLimits />,
			},
			{
				id: 51,
				path: urls.amlCheckResult,
				element: <AMLCheckResult />,
			},
			{
				id: 52,
				path: urls.amlCheck,
				element: <AmlCheck />,
			},
			{
				id: 53,
				path: urls.amlHistory,
				element: <AMLHistoryPage />,
			},
			{
				id: 54,
				path: urls.accessRestricted,
				element: <AccessRestricted />,
			},
			{
				id: 55,
				path: urls.cardDetails,
				element: <CardDetails />,
			},
		],
	},
];

export { routes };
